import { lazy } from 'react';

const EmployeeView = lazy(() => import('./EmployeeView'));

export default EmployeeView;
